/**
 * @generated SignedSource<<0a3a23a7659db70763874107791bd923>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type ACLPrincipalPickerPrincipalsRefetchQuery$variables = {
  userGroupsFilter?: FilterElementInput | null | undefined;
  userGroupsFirst?: number | null | undefined;
  usersFilter?: FilterElementInput | null | undefined;
  usersFirst?: number | null | undefined;
};
export type ACLPrincipalPickerPrincipalsRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ACLPrincipalPicker_principals">;
};
export type ACLPrincipalPickerPrincipalsRefetchQuery = {
  response: ACLPrincipalPickerPrincipalsRefetchQuery$data;
  variables: ACLPrincipalPickerPrincipalsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userGroupsFilter"
  },
  {
    "defaultValue": 1000,
    "kind": "LocalArgument",
    "name": "userGroupsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "usersFilter"
  },
  {
    "defaultValue": 1000,
    "kind": "LocalArgument",
    "name": "usersFirst"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentPrincipal",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ACLPrincipalPickerPrincipalsRefetchQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "userGroupsFilter",
            "variableName": "userGroupsFilter"
          },
          {
            "kind": "Variable",
            "name": "userGroupsFirst",
            "variableName": "userGroupsFirst"
          },
          {
            "kind": "Variable",
            "name": "usersFilter",
            "variableName": "usersFilter"
          },
          {
            "kind": "Variable",
            "name": "usersFirst",
            "variableName": "usersFirst"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ACLPrincipalPicker_principals"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ACLPrincipalPickerPrincipalsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filterElement",
            "variableName": "userGroupsFilter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "userGroupsFirst"
          }
        ],
        "concreteType": "UserGroupConnection",
        "kind": "LinkedField",
        "name": "userGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  (v2/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filterElement",
            "variableName": "usersFilter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "usersFirst"
          }
        ],
        "concreteType": "UserConnection",
        "kind": "LinkedField",
        "name": "users",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  (v1/*:: as any*/),
                  (v2/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8b8c529e79d6485387dbab289d861a0a",
    "id": null,
    "metadata": {},
    "name": "ACLPrincipalPickerPrincipalsRefetchQuery",
    "operationKind": "query",
    "text": "query ACLPrincipalPickerPrincipalsRefetchQuery(\n  $userGroupsFilter: FilterElementInput\n  $userGroupsFirst: Int = 1000\n  $usersFilter: FilterElementInput\n  $usersFirst: Int = 1000\n) {\n  ...ACLPrincipalPicker_principals_WNoTN\n}\n\nfragment ACLPrincipalPicker_principals_WNoTN on Query {\n  userGroups(first: $userGroupsFirst, filterElement: $userGroupsFilter) {\n    edges {\n      node {\n        name\n        roleAssignmentPrincipal\n        id\n      }\n    }\n  }\n  users(first: $usersFirst, filterElement: $usersFilter) {\n    edges {\n      node {\n        email\n        name\n        roleAssignmentPrincipal\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e19aa5258cd54f723b4bb7ad6b3e145";

export default node;
